export default {
  buttonHeightSmall: '14px',
  buttonHeightMedium: '18px',
  buttonHeightLarge: '22px',
  buttonWidthSmall: '14px',
  buttonWidthMedium: '18px',
  buttonWidthLarge: '22px',
  buttonWidthPressedSmall: '20px',
  buttonWidthPressedMedium: '24px',
  buttonWidthPressedLarge: '28px',
  railHeightSmall: '18px',
  railHeightMedium: '22px',
  railHeightLarge: '26px',
  railWidthSmall: '32px',
  railWidthMedium: '40px',
  railWidthLarge: '48px'
};